import log from 'loglevel';

// change level to DEBUG for debugging, use WARN for production
log.setLevel('DEBUG', true);

export default log;
